import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';

class RegistersAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Registers';
  controllerName = 'Registers';

  /**Đường dẫn API */
  insertRegisterInfoUrl = 'do-register';
  activeVerifyCodeUrl = 'do-active-verifycode';
  checkExistCompanyUrl = 'check-exist-company';
  checkActiveLinkUrl = 'check-active-link';
  sendVerifyCodeUrl = 'send-verify-code';
  activeRegisterUrl = 'active-register';
  getEmailSendVerifyCodeUrl = 'get-email-send-verify-code';
  listRegister = 'list';
  updateInfo = 'update-register';
  insertRegisterDataUrl = 'insert-register-data';
  /**
   * Thực hiện đăng ký domain(Bước 1)
   */
  doRegisterInfo(model) {
    let request = {
      url: [this.getAPIUrl(), this.insertRegisterInfoUrl].join('/'),
      data: JSON.stringify({ model: model }),
      timeout: 120000 
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Thực hiện đăng ký domain (Bước 3)
   */
  doActiveVerifyCode(model) {
    let request = {
      url: [this.getAPIUrl(), this.activeVerifyCode].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Kiểm tra tồn tại domain
   */
  checkExistCompany(model) {
    let request = {
      url: [this.getAPIUrl(), this.checkExistCompanyUrl].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Kiểm tra tồn tại link active
   */
  checkActiveLink(model) {
    let request = {
      url: [this.getAPIUrl(), this.checkActiveLinkUrl].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Gửi lại mã code
   */
  async sendVerifyCode(model) {
    let request = {
      url: [this.getAPIUrl(), this.sendVerifyCodeUrl].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Gửi lại mã code
   */
  activeRegister(model) {
    let request = {
      url: [this.getAPIUrl(), this.activeRegisterUrl].join('/'),
      data: JSON.stringify(model),
      timeout: 120000
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  getEmailSendVerifyCode(model) {
    let request = {
      url: [this.getAPIUrl(), this.getEmailSendVerifyCodeUrl].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async getInforRegister(model) {
    let request = {
      url: [this.getAPIUrl(), this.listRegister].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async updateInformation(parameter) {
    let request = {
      url: [this.getAPIUrl(), this.updateInfo].join('/'),
      data: JSON.stringify({ model: parameter }),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Description: Insert dữ liệu Register cho Admin
   * Created by: ndthi
   * Created date: 2024-07-23
   */
  insertRegisterData(model) {
    let request = {
      url: [this.getAPIUrl(), this.insertRegisterDataUrl].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.postAsync(request);
    return res;
  }
}
export default new RegistersAPI();
